<div class="overlay-spinner" *ngIf="LoaderStatus">
  <div class="d-flex justify-content-center">
    <div class="spinner-border text-warning" style="width: 3rem; height: 3rem; " role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
<div class="mx-5 pb-5">
  <app-pages-header></app-pages-header>
  <div class="row bg-white bottom-page-shadow rounded-bottom-extra mx-1">
    <div class="col pt-3 ">
      <p> <span class="fw-bold">Penyenggaraan</span> - Carian Hubungan </p>
      <ul class="nav nav-pills nav-justified mb-3 tabs-bg shadow rounded py-2 ps-10 pe-10 mx-4" id="pills-tab"
          role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link active" id="pills-hubungan-firma-tab" data-bs-toggle="pill"
                  data-bs-target="#pills-hubungan-firma" type="button" role="tab" aria-controls="pills-hubungan-firma"
                  aria-selected="true" (click)="GetFirmRelationship(FirmIDSession)">
            Hubungan Firma
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="pills-hubungan-ejen-tab" data-bs-toggle="pill"
                  data-bs-target="#pills-hubungan-ejen" type="button" role="tab"
                  aria-controls="pills-hubungan-ejen" aria-selected="false" (click)="GetAgentRelationship(FirmIDSession)">
            Hubungan Ejen
          </button>
        </li>
      </ul>

      <!-- HUBUNGAN FIRMA -->
      <div class="tab-content pb-5 mx-4" id="pills-tabContent">
        <div class="tab-pane fade show active" id="pills-hubungan-firma" role="tabpanel" aria-labelledby="pills-hubungan-firma-tab" tabindex="0">
          <div class="d-flex flex-row justify-content-center align-items-center pt-2">
            <p class="mx-5"><img class="pe-2" src="./assets/icons/PentadbirIcon.svg" alt="...">Pentadbir</p>
            <p class="mx-5"><img class="pe-2" src="./assets/icons/EjenCukaiIcon.svg" alt="...">Ejen Cukai</p>
            <p class="mx-5"><img class="pe-2" src="./assets/icons/PenyeliaIcon.svg" alt="...">Penyelia</p>
            <p class="mx-5"><img class="pe-2" src="./assets/icons/StaffIcon.svg" alt="...">Staf</p>
          </div>
          <div class="accordion px-5 pt-1 pb-3" id="resultAcordion">
            <div class="accordion-item border-0">
              <h2 class="accordion-header m-0" id="headingOne">
                <button class="accordion-button primary-colour text-black shadow rounded-top-extra" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  Hubungan Firma
                </button>
              </h2>
              <div id="collapseOne" class="accordion-collapse collapse show bottom-page-shadow default-content-bg-colour rounded-bottom-extra" aria-labelledby="headingOne" data-bs-parent="#resultAcordion">
                <div class="accordion-body">
                  <div class="mx-5 px-3 pb-5 pt-3" >
                    <cdk-tree [dataSource]="dataSourceFirm" [treeControl]="treeControl">
                      <cdk-tree-node *cdkTreeNodeDef="let node; when: hasChild" cdkTreeNodePadding [style.display]="shouldRenderFirm(node) ? 'flex' : 'none'" class="example-tree-node">
                        <button class="btn" cdkTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name" (click)="node.isExpanded = !node.isExpanded" [style.visibility]="node.expandable ? 'visible' : 'hidden'">
                          <mat-icon class="mat-icon-rtl-mirror">
                            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                          </mat-icon>
                        </button>
                        <img [ngClass]="node.role === 'Pentadbir' ? '' : 'd-none' " class="pe-2" src="./assets/icons/PentadbirIcon.svg" alt="..."><img [ngClass]="node.role === 'Ejen' ? '' : 'd-none' " class="pe-2" src="./assets/icons/EjenCukaiIcon.svg" alt="..."><img [ngClass]="node.role === 'Penyelia' ? '' : 'd-none' " class="pe-2" src="./assets/icons/PenyeliaIcon.svg" alt="..."><img [ngClass]="node.role === 'Staf' ? '' : 'd-none' " class="pe-2" src="./assets/icons/StaffIcon.svg" alt="...">{{node.name}}
                      </cdk-tree-node>
                    </cdk-tree>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- HUBUNGAN EJEN -->
        <div class="tab-pane fade" id="pills-hubungan-ejen" role="tabpanel" aria-labelledby="pills-hubungan-ejen-tab" tabindex="0">
          <div class="d-flex flex-row justify-content-center align-items-center pt-2">
            <p class="mx-5"><img class="pe-2" src="./assets/icons/EjenCukaiIcon.svg" alt="...">Ejen Cukai</p>
            <p class="mx-5"><img class="pe-2" src="./assets/icons/PenyeliaIcon.svg" alt="...">Penyelia</p>
            <p class="mx-5"><img class="pe-2" src="./assets/icons/StaffIcon.svg" alt="...">Staf</p>
          </div>
          <div class="accordion px-5 pt-1 pb-3" id="resultAcordion">
            <div class="accordion-item border-0">
              <h2 class="accordion-header m-0" id="headingOne">
                <button class="accordion-button primary-colour text-black shadow rounded-top-extra" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  Hubungan Firma
                </button>
              </h2>
              <div id="collapseOne" class="accordion-collapse collapse show bottom-page-shadow default-content-bg-colour rounded-bottom-extra" aria-labelledby="headingOne" data-bs-parent="#resultAcordion">
                <div class="accordion-body">
                  <div class="mx-5 px-3 pb-5 pt-3">
                    <cdk-tree [dataSource]="dataSource" [treeControl]="treeControl">
                      <cdk-tree-node *cdkTreeNodeDef="let node; when: hasChild" cdkTreeNodePadding [style.display]="shouldRender(node) ? 'flex' : 'none'" class="example-tree-node">
                        <button class="btn" cdkTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name" (click)="node.isExpanded = !node.isExpanded" [style.visibility]="node.expandable ? 'visible' : 'hidden'">
                          <mat-icon class="mat-icon-rtl-mirror">
                            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                          </mat-icon>
                        </button>
                        <img [ngClass]="node.role === 'Ejen Cukai' ? '' : 'd-none' " class="pe-2" src="./assets/icons/EjenCukaiIcon.svg" alt="..."><img [ngClass]="node.role === 'Penyelia' ? '' : 'd-none' " class="pe-2" src="./assets/icons/PenyeliaIcon.svg" alt="..."><img [ngClass]="node.role === 'Staf' ? '' : 'd-none' " class="pe-2" src="./assets/icons/StaffIcon.svg" alt="...">{{node.name}}
                      </cdk-tree-node>
                    </cdk-tree>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
